import { ANALYTIC_EVENTS, logEvent, setAnalyticsEligibilityInfo } from "../service/analyticsService";
import { MemberEligibilityInfo } from "../types";
import { ViewRequest, request } from "./request";

export const getMemberEligibility = async (authToken: string, body?: Partial<ViewRequest>) => {
  try {
    const response = (await request<typeof body, MemberEligibilityInfo>({
      endpoint: "/member/get_eligibility_data",
      body: { ...(body || {}) },
    }, authToken)) as MemberEligibilityInfo;
    setAnalyticsEligibilityInfo(response.plan.client_id, response.plan.name);
    return response;
  } catch (err) {
    logEvent(ANALYTIC_EVENTS.ERRORS.getMemberEligibilityInfo);
    throw err;
  }
};
